module.exports = __webpack_public_path__ + "static/media/icon-more-black.21e5ad57.svg";